import {
  Box,
  CircularProgress,
  LinearProgress as LinearProgressMui,
  Stack,
  Typography,
  styled,
  useMediaQuery,
} from "@mui/material";
import { FC, memo } from "react";
import { JSX } from "react/jsx-runtime";

const TextContainer = styled("div")({
  position: "absolute",
  display: "flex",
  top: 0,
  left: 0,
  width: "100%",
  height: "25px",
});

const LinearProgress = styled(LinearProgressMui)({
  height: "25px",
  width: "100%",
});

const LinearContainer = styled(Box)({
  width: "100%",
  height: "25px",
  position: "relative",
});

const StackContainer = styled(Stack)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
});

interface IProgressBarActiveAux {
  status: string;
  progress: number;
  badgeText?: string;
  testLabel?: string;
}

const ProgressBarActiveAux: FC<IProgressBarActiveAux> = ({ status, progress, badgeText, testLabel = "processing" }) => {
  const isLargeScreen = useMediaQuery("(min-width:800px)");

  return (
    <StackContainer data-status={status} test-label={testLabel}>
      {isLargeScreen ? (
        <LinearContainer>
          <LinearProgress variant="determinate" value={progress} />
          {badgeText ? (
            <TextContainer>
              <Stack sx={{ flexDirection: "row", alignItems: "center", width: "100%", justifyContent: "center" }}>
                <Typography
                  test-label="badge-test-progress-bar-active"
                  sx={{ fontSize: "1em", color: "text10.main" }}
                  className="badgeText"
                >
                  {badgeText}
                </Typography>
              </Stack>
            </TextContainer>
          ) : null}
        </LinearContainer>
      ) : (
        <CircularProgress variant="determinate" value={progress} size="20px" />
      )}
    </StackContainer>
  );
};

interface IProgressBarWaitingAux {
  status: string;
  badgeText: string;
  testLabel?: string;
  statusIcon?: JSX.Element;
}

const ProgressBarWaitingAux: FC<IProgressBarWaitingAux> = ({
  status,
  badgeText,
  testLabel = "processing",
  statusIcon,
}) => {
  const isLargeScreen = useMediaQuery("(min-width:800px)");
  return (
    <StackContainer data-status={status} test-label={testLabel}>
      {isLargeScreen ? (
        <LinearContainer>
          <LinearProgress />
          <TextContainer>
            <Stack sx={{ flexDirection: "row", alignItems: "center", width: "100%", justifyContent: "center" }}>
              <Stack sx={{ marginRight: "5px" }}>{statusIcon}</Stack>
              <Typography
                test-label="badge-test-progress-bar-waiting"
                sx={{ fontSize: "1em", color: "text10.main" }}
                className="badgeText"
              >
                {badgeText}
              </Typography>
            </Stack>
          </TextContainer>
        </LinearContainer>
      ) : (
        <CircularProgress size="20px" />
      )}
    </StackContainer>
  );
};

const ProgressBarWaiting = memo(ProgressBarWaitingAux);
const ProgressBarActive = memo(ProgressBarActiveAux);

export { ProgressBarActive, ProgressBarWaiting };
